import styled from "styled-components";
import { Menu as AntdMenu, Typography } from "antd";

export const Menu = styled(AntdMenu)`
  float: right;
  background-color: ${({ theme }) => theme.token.colorFillTertiary};
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  height: 74px;
  width: 180px;

  @media (min-width: 576px) {
    width: 280px;
  }

  .ant-menu-submenu {
    height: 100%;
    width: 100%;
    padding: 0;
  }

  .ant-menu-submenu-title {
    display: flex;
    align-items: flex-start;
    height: 100%;

    .ant-menu-title-content {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      padding: 8px 20px 8px 26px;
    }
  }
`;

export const MenuText = styled(Typography.Text).attrs({
  type: "secondary",
  ellipsis: true,
})`
  line-height: initial;
`;
